module.exports = __webpack_public_path__ + "static_portal/img/body_parts_speed_bad_sequence.e33027bb.jpg";